__turbopack_context__.v({
  "app_light_theme": "HeroInfoContent-module-scss-module__jMyHHa__app_light_theme",
  "blueSubtitle": "HeroInfoContent-module-scss-module__jMyHHa__blueSubtitle",
  "center": "HeroInfoContent-module-scss-module__jMyHHa__center",
  "end": "HeroInfoContent-module-scss-module__jMyHHa__end",
  "heroInfoContent": "HeroInfoContent-module-scss-module__jMyHHa__heroInfoContent",
  "note": "HeroInfoContent-module-scss-module__jMyHHa__note",
  "scrollButton": "HeroInfoContent-module-scss-module__jMyHHa__scrollButton",
  "secondButton": "HeroInfoContent-module-scss-module__jMyHHa__secondButton",
  "start": "HeroInfoContent-module-scss-module__jMyHHa__start",
  "subtitle": "HeroInfoContent-module-scss-module__jMyHHa__subtitle",
  "title": "HeroInfoContent-module-scss-module__jMyHHa__title",
});
